import styled from "styled-components";
import { MobileBlogFeed } from "../../../../../common/others/blog/views/mobile/styled.js";
export const BlogContainer = styled.div.withConfig({
    displayName: "styled__BlogContainer",
    componentId: "sc-a9aca4b9-0"
})`
	${MobileBlogFeed} {
		border-bottom: 1px solid ${({ theme  })=>theme.colors.grays.light};
	}
`;

//# sourceMappingURL=styled.js.map